import React from "react";
import Image from "../components/GatsbyImage";
import ExternalLink from "./ExternalLink";
import { getImage } from "gatsby-plugin-image";

const Certificates = ({ lexicon, certificate }) => {
  if (!certificate || certificate.length === 0) return null;
  return (
    <section className="container pb-20 mx-auto">
      {lexicon.certificates && (
        <h2 className="flex-1 title certificate-title">
          {lexicon.certificates}
        </h2>
      )}
      <ul className="flex flex-wrap justify-center max-w-lg p-10 m-auto">
        {certificate.map(
          ({
            image: {
              description: alt,
              file: { fileLocal },
            },
            title,
            url,
          }) => (
            <li key={title} className="w-1/2 p-2 sm:w-1/4 lg:px-4 lg:py-4">
              {url ? (
                <ExternalLink
                  href={url}
                  title={title}
                  showExternalIcon={false}
                  className="flex-1"
                >
                  <Image image={getImage(fileLocal)} alt={alt} />
                </ExternalLink>
              ) : (
                <Image image={getImage(fileLocal)} alt={alt} />
              )}
            </li>
          )
        )}
      </ul>
    </section>
  );
};

export default Certificates;
